import { Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export function FormerMemberBadge() {
  const { t } = useTranslation();

  return (
    <Text span size="xs" c="dimmed">
      {' '}
      {t('common.formerMember')}
    </Text>
  );
}
